import { gql } from '@apollo/client';

export const GET_POWERBI_REPORT = {
  query: gql`
    query GetPowerBIReport($id: ID!) {
      powerBI {
        powerBIConfig(id: $id) {
          id
          name
          embedUrl
          webUrl
          enableRls
          errorMessage
          dataSet {
            name
          }
          currentUserValid
          users {
            identifier
            datasetUserAccessRight
          }
          username
          groupName
          pages {
            displayName
            name
            order
          }
          embedToken {
            token
            expiration
          }
        }
      }
    }
  `,
  queryNode: 'powerBIConfig',
  rootNode: 'powerBI',
  textField: 'name',
  keyField: 'id',
};
export const GET_POWERBI_GROUPS = {
  query: gql`
    query GetPowerBIGroups {
      powerBI {
        powerBIGroups {
          id
          display
        }
      }
    }
  `,
  queryNode: 'powerBIGroups',
  rootNode: 'powerBI',
  textField: 'display',
  keyField: 'id',
};
export const GET_POWERBI_ROLES = {
  query: gql`
    query GetPowerBIRoles($id: ID, $workSpaceId: ID, $reportId: ID) {
      powerBI {
        powerBIRoles(id: $id, workSpaceId: $workSpaceId, reportId: $reportId) {
          id
          display
        }
      }
    }
  `,
  queryNode: 'powerBIRoles',
  rootNode: 'powerBI',
  textField: 'display',
  keyField: 'id',
};
export const GET_POWERBI_SETTINGS = {
  query: gql`
    query GetPowerBiSettings {
      powerBI {
        PowerBiSettings {
          userName
        }
      }
    }
  `,
  queryNode: 'PowerBiSettings',
  rootNode: 'powerBI',
  textField: 'userName',
  keyField: 'userName',
};
export const GET_POWERBI_REPORTS = {
  query: gql`
    query GetPowerBIReports($id: ID!) {
      powerBI {
        powerBIReports(id: $id) {
          id
          display
          datasetId
        }
      }
    }
  `,
  queryNode: 'powerBIReports',
  rootNode: 'powerBI',
  textField: 'display',
  keyField: 'id',
};
export const GET_POWERBI_CATALOGS = {
  query: gql`
    query GetpowerBICatalogs($id: ID!) {
      powerBI {
        powerBICatalogs(id: $id) {
          id
          display
        }
      }
    }
  `,
  queryNode: 'powerBICatalogs',
  rootNode: 'powerBI',
  textField: 'display',
  keyField: 'id',
};
export const GET_POWERBI_TABLES = {
  query: gql`
    query GetPowerBITables($id: ID!, $catalogName: ID) {
      powerBI {
        powerBITables(id: $id, catalogName: $catalogName) {
          id
          display
          catalog
        }
      }
    }
  `,
  queryNode: 'powerBITables',
  rootNode: 'powerBI',
  textField: 'display',
  keyField: 'id',
};
export const GET_POWERBI_FIELDS = {
  query: gql`
    query GetPowerBIFields($id: ID!, $catalogName: ID, $tableName: ID) {
      powerBI {
        powerBIFields(id: $id, catalogName: $catalogName, tableName: $tableName) {
          id
          table
          catalog
          display
        }
      }
    }
  `,
  queryNode: 'powerBIFields',
  rootNode: 'powerBI',
  textField: 'display',
  keyField: 'id',
};
export const GET_POWERBI_FILTER_VALUES = {
  query: gql`
    query GetPowerBIValues($id: ID!) {
      powerBI {
        powerBIFilterValues(id: $id) {
          id
        }
      }
    }
  `,
  queryNode: 'powerBIFilterValues',
  rootNode: 'powerBI',
  textField: 'id',
  keyField: 'id',
};

export const GET_POWERBI_FILTER_DEFAULT_VALUES = {
  query: gql`
    query GetPowerBIFilterDefaultValues($id: ID!, $table: String, $field: String) {
      powerBI {
        powerBIFilterDefaultValues(id: $id, table: $table, field: $field) {
          id
          display
        }
      }
    }
  `,
  queryNode: 'powerBIFilterDefaultValues',
  rootNode: 'powerBI',
  textField: 'display',
  keyField: 'id',
};
export const MUTATION_SYNCHRONIZE_EMBEDREPORT = gql`
  mutation synchronizeEmbedReport($id: ID!) {
    synchronizeEmbedReport(id: $id) {
      message
      isError
      totalRecords
    }
  }
`;
export const GET_EMBEDREPORTDETAIL_BY_ID = {
  query: gql`
    query GetEmbedReportById($id: ID!) {
      embedReport(id: $id) {
        id
        market {
          id
          display
        }
        type
        inactive
        status
        powerReportId
        powerWorkspaceId
        embedArea
        embedPage
        reportName
        contactOrSupportEmail
        viewMode
        bgColor
        appInstance
        rLS
        embedded
        customGroups
        groups
        netGross
        description
        pages {
          id
          type
          pageCode
          pageName
          displayName
        }
        formatTags {
          id
          display
          description
        }
        filters {
          id
          type
          cascadeField
          cascadeFilter {
            id
            display
          }
          scope
          defaultValue
          expression
          field
          filterName
          method
          order
          pages
          table
          display
          isNot
        }
      }
    }
  `,
  queryNode: 'embedReport',
  textField: 'reportName',
  keyField: 'id',
};
export const MUTATION_ADDTRAIL = gql`
    mutation auditTrail($productId: ID!, $productName: String) {
    bulkOperations {
      auditTrail(productId: $productId, productName: $productName) {
        message
        isError
        totalRecords
      }
    }
  }
`;

export const MUTATION_GETTOKEN = gql`
    mutation refreshtoken($productId: ID!) {
    bulkOperations {
      refreshtoken(productId: $productId) {
        message
        code
      }
    }
  }
`;